import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PointElement,
    Tooltip
} from 'chart.js';

import CaloriesChart from '../components/nutrition/charts/CaloriesChart';
import EnergyChart from '../components/nutrition/charts/EnergyChart';
import FatChart from '../components/nutrition/charts/FatChart';
import OtherChart from '../components/nutrition/charts/OtherChart';
import VitaminsChart from '../components/nutrition/charts/VitaminsChart';

// CHART.JS REGISTRATION

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    ArcElement,
    LineController,
    Tooltip,
    Legend,
    LineElement,
    PointElement
);

// COLOR CONSTANTS

export const CHART_COLORS = {
    blue: '#6495ED',
    red: '#FD6585',
    yellow: '#FECC60',
    green: '#A4EAA5'
};

export const MACRO_COLORS = {
    Kolhydrater: CHART_COLORS.red,
    Protein: CHART_COLORS.yellow,
    Fett: CHART_COLORS.green,
    Alkohol: CHART_COLORS.blue
};

// HELPERS

export const round = (n) => {
    if (!Number.isFinite(n)) return 0;
    if (Math.abs(n) < 1) return +n.toFixed(3);
    return +n.toFixed(1);
};

// CHART OPTIONS

export const baseBarOptions = {
    plugins: {
        legend: {
            display: false
        }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        y: {
            beginAtZero: true,
            ticks: { precision: 0 },
            grid: { color: '#f0f0f0' }
        },
        x: {
            grid: { display: false },
            ticks: { color: '#222222BF' }
        }
    }
};

export const options = {
    ...baseBarOptions,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                usePointStyle: true,
                pointStyle: 'rectangle',
                boxWidth: 12,
                padding: 16,
                font: {
                    size: 14,
                    family: 'ITC Avant Garde Gothic W01'
                },
                color: '#222222BF'
            }
        }
    }
};

export const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    fullSize: true,
    align: 'center',
    layout: { padding: { bottom: 30 } },
    elements: { arc: { borderWidth: 0 } },
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                usePointStyle: true,
                pointStyle: 'rect',
                boxWidth: 12,
                boxPadding: 20,
                padding: 20,
                font: {
                    size: 14,
                    family: 'ITC Avant Garde Gothic W01',
                    weight: 700
                },
                color: '#222222BF'
            }
        },
        tooltip: {
            usePointStyle: true,
            displayColors: true,
            boxWidth: 12,
            boxHeight: 12,
            boxPadding: 5,
            padding: 6,
            borderWidth: 0,
            multiKeyBackground: 'transparent',
            callbacks: {
                title: () => '',
                label: (ctx) => `${ctx.label}: ${ctx.parsed}%`,
                labelColor: (ctx) => ({
                    backgroundColor: ctx.dataset.backgroundColor[ctx.dataIndex],
                    borderColor: 'transparent',
                    borderWidth: 0
                }),
                labelPointStyle: () => ({
                    pointStyle: 'rect',
                    rotation: 0
                })
            },
            bodyFont: { weight: 'bold', size: 12 }
        }
    }
};

// CHART CONFIGURATION

export const CHART_CONFIG = {
    energy: {
        Component: EnergyChart,
        title: 'Min Energifördelning (E %)',
        variant: 'pie',
        extraProps: { singleChart: false }
    },

    desired_energy: {
        Component: EnergyChart,
        title: 'Önskad fördelning (E %)',
        variant: 'pie',
        extraProps: { singleChart: false }
    },

    fat: { Component: FatChart, title: 'Fett' },

    calories: { Component: CaloriesChart, title: 'Kalorier' },

    other: { Component: OtherChart, title: 'Övriga ämnen' },

    vitamins: { Component: VitaminsChart, title: 'Vitaminer och mineraler' }
};
